@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.bundle-container {
  width: 100%;
  background-color: var(--grey-100);
  border-top: 1px solid var(--grey-300);
}

.bundle-row {
  display: flex;
  width: 100%;
  font-size: 12px;
  color: var(--grey-700);
}

.bundle-cell {
  padding: @space-4 @space-16;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.bundle-product-cell {
  .bundle-cell;
  flex: 240 0 auto;
  width: 240px;
}

.bundle-location-cell {
  .bundle-cell;
  flex: 200 0 auto;
  width: 200px;
}

.selected-location {
  height: 24px;
}

.bundle-lot-cell,
.bundle-exp-date-cell {
  .bundle-cell;
  flex: 140 0 auto;
  width: 140px;
}

.bundle-qty-cell,
.bundle-empty-cell {
  .bundle-cell;
  flex: 80 0 auto;
  width: 80px;
  min-height: 24px;
  line-height: 24px;
  justify-content: flex-end;
}

.bundle-cost-cell {
  .bundle-cell;
  flex: 100 0 auto;
  width: 100px;
  min-height: 24px;
  line-height: 24px;
}

.bundle-product {
  display: flex;
  align-items: center;
  width: 100%;
  gap: @space-24;
}

.bundle-product-image {
  width: 50px;
  margin-left: @space-16;
  object-fit: contain;
}

.bundle-product-info {
  display: flex;
  flex-direction: column;
}

.bundle-product-name {
  font-size: 12px;
  line-height: 16px;
}

.bundle-product-sku {
  color: var(--grey-600);
  font-size: 12px;
  line-height: 16px;
}

.quantity-input {
  min-height: 24px;
  line-height: 24px;
}

.cost-input {
  height: 24px;
  label {
    min-width: fit-content;
  }
}

.date-picker {
  display: flex;
  input {
    height: 24px;
  }
  button {
    display: block;
    height: 24px;
  }
}
